export default __webpack_public_path__ + "static/media/150.75329c56.jpg";